import { AmfPosition } from '@frontend/core/lib/domains/sports/positions'
import type { MonitorMetricDef } from './types'

const qbMetrics: MonitorMetricDef[] = [
  { key: 'throwCount', label: 'Throws', unitType: 'count' },
  {
    key: 'highVelocityThrowCount',
    label: 'High Vel Throws',
    unitType: 'count'
  },
  { key: 'completePercentage', label: 'Complete %' },
  { key: 'avgReleaseVelocity', label: 'Release Velocity', unitType: 'speed' },
  { key: 'qbAvgSpin', label: 'Spin', unitType: 'revs' },
  { key: 'qbAvgTimeToThrow', label: 'Time to Throw', unitType: 'time' },
  { key: 'qbAvgDistance', label: 'Avg Distance', unitType: 'distance' }
]

const wrMetrics: MonitorMetricDef[] = [
  { key: 'routeCount', label: 'Routes', unitType: 'count' },
  {
    key: 'routePlusPassedToCount',
    label: 'Route + Passed To',
    unitType: 'count'
  },
  { key: 'catchCompletePercentage', label: 'Catch %' },
  { key: 'avgWorkRate', label: 'Work Rate', unitType: 'workRate' },
  { key: 'avgRouteDistance', label: 'Route Distance', unitType: 'distance' }
]

const punterMetrics: MonitorMetricDef[] = [
  { key: 'puntCount', label: 'Punts', unitType: 'count' },
  { key: 'puntAvgDistance', label: 'Distance', unitType: 'distance' },
  { key: 'avgPuntDistance', label: 'Punt Distance', unitType: 'distance' },
  {
    key: 'puntAvgReleaseVelocity',
    label: 'Release Velocity',
    unitType: 'speed'
  },
  { key: 'puntAvgSpin', label: 'Spin', unitType: 'revs' },
  { key: 'puntAvgExecutionTime', label: 'Execution Time', unitType: 'time' }
]

const kickerMetrics: MonitorMetricDef[] = [
  { key: 'kickCount', label: 'Kicks', unitType: 'count' },
  {
    key: 'kickAvgReleaseVelocity',
    label: 'Release Velocity',
    unitType: 'speed'
  },
  { key: 'goodKickPercentage', label: 'Good Kick %' },
  { key: 'kickAvgSpin', label: 'Spin', unitType: 'revs' },
  { key: 'kickAvgExecutionTime', label: 'Execution Time', unitType: 'time' },
  { key: 'kickAvgDistance', label: 'Kick Distance', unitType: 'distance' },
  { key: 'avgFieldGoalDistance', label: 'FG Distance', unitType: 'distance' }
]

// Returns the technical-monitoring metric set for the given canonical AMF
// position. Unknown positions fall back to QB metrics — same behaviour as the
// original Angular reporting tool.
export function getAmfTechnicalMetrics(
  position: string | null
): MonitorMetricDef[] {
  switch (position) {
    case AmfPosition.WideReceiver:
      return wrMetrics
    case AmfPosition.Punter:
      return punterMetrics
    case AmfPosition.Kicker:
      return kickerMetrics
    case AmfPosition.Quarterback:
    default:
      return qbMetrics
  }
}
